import React, { useContext, useState, useEffect } from 'react';
import styles from './styles/VisibilitySetting.module.css';
import { getFollowVisibility, updateFollowVisibility } from '../../services/FollowerServices';
import AuthContext from '../../context/AuthContext';


const VisibilitySetting = () => {
    const { user } = useContext(AuthContext); // Get logged in user
    const [followVisibility, setFollowVisibility] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchVisibility = async () => {
            if (!user?._id) return;

            try { // Load the visibility configuration from backend
                const data = await getFollowVisibility(user._id);
                setFollowVisibility(data.isVisible);
            } catch (err) {
                console.error('Error fetching follow visibility:', err);
                setError("Unable to load your visibility setting.");
            }
        };

        fetchVisibility();
    }, [user?._id]); // Refetch only when the logged-in user actually changes

    const handleToggle = async () => {
        if (isSaving) return;

        try { // Update
            setIsSaving(true);
            setError("");

            const data = await updateFollowVisibility(!followVisibility);
            setFollowVisibility(data.isVisible);
        } catch (err) {
            console.error('Error updating follow visibility:', err);
            setError("Unable to save. Please try again.");
        } finally {
            setIsSaving(false);
        }
    };

    if (followVisibility === null && !error) {
        return <div>Loading...</div>;
    }

    return (
        <div className={styles.visibilityContainer}>
            <h2>Visibility Settings</h2>

            <div className={styles.section}>
                <div className={styles.followVisibility}>
                    <span>Make follower/following list public</span>

                    <label className={styles.toggle}>
                        <input
                            type="checkbox"
                            checked={Boolean(followVisibility)}
                            onChange={handleToggle}
                            disabled={isSaving}
                        />
                        <span className={styles.slider}></span>
                    </label>
                </div>

                {error && <p className={styles.error}>{error}</p>}
            </div>
        </div>
    );
};


export default VisibilitySetting;
